import { UI_CAPTION_BOLD_DF } from "oolib";
import styled from "styled-components";


export const StyledLabelHeader = styled.div`
  position: sticky;
  top: 0;
  background: white;
  padding: 0 1.4rem 0.8rem 1.4rem;
`;

export const StyledHorizontalLabel = styled(UI_CAPTION_BOLD_DF)`
  position: sticky;
  top: 0;
  background: white;
`;



export const StyledLegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;